import { Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { formattedAmount } from 'modules/banking/lib/paymentHelpers'

export const Amount = ({ amountCents, currency }: { amountCents: number; currency: string }) => {
  const {
    access: { locale },
  } = useCurrentSession()
  return (
    <Text.Normal size="200">
      {formattedAmount({ amountCents: amountCents, currency, locale })}
    </Text.Normal>
  )
}
